import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { InfiniteScrollStore } from '../../../../../modules/shared/store/common/infinite-scroll.store';
import { getGroupsFrag } from './select-user-group.query';

@Injectable()
export class SelectUserGroupStore extends ComponentStoreV2Factory {

}
